import { render } from "./IncomeForm.vue?vue&type=template&id=770db26c"
import script from "./IncomeForm.vue?vue&type=script&lang=js"
export * from "./IncomeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__